module.exports = {"140214001":"新胜街道","140214002":"新平旺街道","140214016":"新泉路街道","140214017":"民胜街道","140214018":"口泉街道","140214023":"平泉路街道","140214025":"和顺街道","140214026":"和瑞街道","140214027":"平盛路街道","140214028":"清泉街街道","140214029":"西花园街道","140214030":"老平旺街道","140214031":"新文街道","140214032":"和旺街道","140214033":"玉龙街道","140214034":"云武街道","140214035":"云燕街道","140214036":"玉泉街道","140214037":"平德街道","140214038":"平喜街道","140214039":"平源街道","140214101":"高山镇","140214102":"云冈镇","140214200":"口泉乡","140214206":"西韩岭乡","140214207":"平旺乡","140214210":"鸦儿崖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140214.json
// module id = 362
// module chunks = 0